var map = {
	"./campaign.svg": "2d7f",
	"./campaign_white.svg": "6bcb",
	"./info.svg": "4fa5",
	"./info_white.svg": "f4cd",
	"./menu.svg": "f804",
	"./menu_white.svg": "5559e",
	"./only-you.svg": "489a",
	"./only-you_white.svg": "4df8",
	"./shop.svg": "2164",
	"./shop_white.svg": "16e6",
	"./tips.svg": "c96a",
	"./tips_white.svg": "f063"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fa80";